import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "components/form/FormContainer";
import { VideosReducerActions } from "reducers/videosReducer";
import ROUTES from "constants/Routes";

const EditVideo = () => {
  const formContent = {
    header: "Edit Video",
    inputs: [
      {
        label: "Video Name",
        fieldName: "name",
        required: true,
      },
      {
        label: "YouTube URL",
        fieldName: "youtube_url",
        type: "url",
        required: true,
        helperText:
          "Paste the exact link to your video. For example: https//youtube.com/watch?xyz",
      },
    ],
  };

  const { id } = useParams();
  const dispatch = useDispatch();
  const kit = useSelector((state) => state.auth.currentKit);
  const videoData = useSelector((state) => state.videos.selectedVideo);
  const {
    getSelectedVideoData,
    setSelectedVideoData,
    saveSelectedVideoChanges,
  } = VideosReducerActions;

  const setVideoData = (fieldName, value) => {
    dispatch(setSelectedVideoData({ ...videoData, [fieldName]: value }));
  };

  const handleSubmit = () => {
    dispatch(saveSelectedVideoChanges(kit, videoData));
  };

  useEffect(() => {
    if (kit) dispatch(getSelectedVideoData(kit, id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kit]);

  return (
    <FormContainer
      formContent={formContent}
      data={videoData}
      setNewData={setVideoData}
      handleSubmit={handleSubmit}
      listPath={`${ROUTES.SETTINGS_PREFIX}${ROUTES.VIDEOS}`}
    />
  );
};

export default EditVideo;
